'use strict';

const BaseModel = require('./baseModel');

class ApplicantProfile extends BaseModel {
  constructor(schema = applicantProfileSchema) {
    super(schema);
  }

  static getSchema() {
    return applicantProfileSchema;
  }
}

const applicantProfileSchema = {
  // // Prelim Application

  employmentStatus: {
    required: {
      message: 'This field is required.'
    }
  },
  availabilityDate: {
    required: {
      message: 'This field is required.'
    }
  },
  totalYearsExperienceNumeric: {
    required: {
      message: 'This field is required.'
    }
  },
  industryYearsExperienceNumeric: {
    required: {
      message: 'This field is required.'
    }
  },
  workedLastInIndustry: {
    required: {
      message: 'This field is required.'
    }
  },
  industryTypes: {
    required: {
      message: 'This field is required.'
    }
  },
  foundUsVia: {
    required: {
      message: 'This field is required.'
    }
  },
  foundUsOther: {
    required: {
      message: 'This field is required.'
    }
  },
  optIntoNewsletter: {
    required: {
      message: 'This field is required.'
    }
  },
  mostRecentSegment: {
    required: {
      message: 'This field is required.'
    }
  },
  mostRecentPosition: {
    required: {
      message: 'This field is required.'
    }
  },
  mostRecentDepartment: {
    required: {
      message: 'This field is required.'
    }
  },

  // // Admin-side

  // Explanation of questions fields
  mostRecentWork: {
    required: {
      message: 'This field is required.'
    }
  },
  mostRecentWorkFirmType: {
    required: {
      message: 'This field is required.'
    }
  },
  mostRecentWorkDuration: {
    required: {
      message: 'This field is required.'
    }
  },
  previousTypeOfWork: {
    required: {
      message: 'This field is required.'
    }
  },
  hasWorkedRemotely: {
    required: {
      message: 'This field is required.'
    }
  },
  hasWorkedRemotelyComment: {
    required: {
      message: 'This field is required.'
    }
  },

  // Prelim Interview fields
  currentEmploymentStatus: {
    required: {
      message: 'This field is required.'
    }
  },
  wantToWorkStatus: {
    required: {
      message: 'This field is required.'
    }
  },
  workFromHomeReason: {
    required: {
      message: 'This field is required.'
    }
  },
  retireReasonId: {
    required: {
      message: 'This field is required.'
    }
  },
  returnToWorkReasonId: {
    required: {
      message: 'This field is required.'
    }
  },


  // // Applicant-side

  // Availability information
  // availabilityDate comes from Prelim Application section
  availabilityHoursPerDay: {
    required: {
      message: 'This field is required.'
    }
  },
  availabilityHoursPerWeek: {
    required: {
      message: 'This field is required.'
    }
  },
  workDays: {
    required: {
      message: 'This field is required.'
    },
    isLength: {
      options: {min: 1},
      message: 'Must select at least 1'
    },
  },

  // Home Office
  hasDedicatedHomeOffice: {
    required: {
      message: 'This field is required.'
    }
  },
  computerTypeId: {
    required: {
      message: 'This field is required.'
    }
  },
  computerOperatingSystemId: {
    required: {
      message: 'This field is required.'
    }
  },
  hasHighSpeedInternet: {
    required: {
      message: 'This field is required.'
    }
  },
  internetTypeId: {
    required: {
      message: 'This field is required.'
    }
  },
  canUpgradeTechnology: {
    required: {
      message: 'This field is required.'
    }
  },

  // Career Sumary
  careerSummary: {
    required: {
      message: 'This field is required.'
    }
  },// Career Sumary
  personalityAssessmentComment: {
    required: {
      message: 'This field is required.'
    }
  },
};

module.exports = ApplicantProfile;



// WEBPACK FOOTER //
// ./shared/models/applicantProfile.js